
<template>
<Loader v-if="loader" />
    
</template>

<script>

import { FilterMatchMode } from 'primevue/api';
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import Loader from '@/components/Loader.vue'

export default {
    components: {
      Loader
    },
    setup() {
                
      const loader = ref(false);
      const items = ref([]);
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const service = new Service(self.$http, self.$eventBus)

      onMounted(() => {    
        console.log(service);   
      })
      

      
      return { 
        items,
        loader,
        formatDate, 
        filters,
      }
    }
}
</script>
